import { getToken, login, logout as msalLogout, getAccountName } from "./authConfig";

const isDev = process.env.NODE_ENV === "development";

export function logout(){
  msalLogout()
}
export function getCustomerName(){
  return getAccountName()
}

export async function getReports(frequency,count,type){
  const frequencyType = "weekly"
  var idToken = await getToken()
  if(type!=='organizer2'){
    let querybody =''
    if(type==='organizer')
    querybody =`query {organizer(jwt:"${idToken}",count:${count}){${frequencyType}{startDate,endDate,completedTaskCounter {count,averageLeadTimeInDays,nonRecurring{id,name,leadTimeInDays},recurring{count,name}}, scheduleStickinessCounter {percent}, addedTaskCounter {count}}}}`
    else if(type==='learning')
      querybody =`query {learning(jwt:"${idToken}",count:${count}){${frequencyType}{startDate,endDate,highEffortProgress{items{percentage,name,estimatedCompletionDate}},completedKnowledgeCounter {count}}}}`
     

    const response= await authFetch(reportsGraphQLURL, {
			method: 'POST',
			body: JSON.stringify({ query: querybody }),
		})
    return response.json();
  }else{
  /*
  const response = await fetch(reportsBaseURL+"?startDate="+startDate+"&endDate="+endDate+"&jwt="+idToken)
  
  if (!response.ok) {
    throw new Error('Data coud not be fetched!')
  } else {
    var responseJson =  response.json()

    return responseJson
  }
  */
}
  //.then(response => response.json())
  //.then(jsonResponse => callbackFunction(jsonResponse))
}

export const baseURL="https://organizerlifekitindnew-bxgmf5cvc0cjgcdm.indiasouthcentral-01.azurewebsites.net"
export const reportsBaseURL="https://calcium-adapter-395314.uc.r.appspot.com"
export const reportsGraphQLURL="https://reports-web-api-x6m4jkio6q-uc.a.run.app/graphql"
export function handleResponse(response){
if(response.ok){
  return response.json()
} else if(response.status===401){
  if (isDev) {
    console.warn("401 from API — token in localStorage AUTHTOKEN is missing/invalid; skipping login redirect in dev mode");
    return;
  }
  login()
} else {
  throw new Error("Request failed: " + response.status + " " + response.statusText)
}
}

export async function getSuggestions(id,page,date,size=5){
  let url = baseURL+'/v1/task/suggestedTime?size='+size+'&taskId='+id+'&page='+page
  if(date!==undefined){
    url+="&date="+date
  }
  const response=  await authFetch(url, {
    method: 'GET',
  }).then(res => res.json());//.then(res => res.json())
  return response;
}

export async function getHeader(){
  var idToken = await getToken()
  return {
    'Authorization':"Bearer "+ idToken,
    'Accept': 'application/json',
		'Content-Type': 'application/json',
  }

}

export async function authFetch(url, options = {}){
  const headers = await getHeader()
  return fetch(url, { ...options, headers: { ...headers, ...(options.headers || {}) } })
}